/* Lifetones slide-out cart + cart page (Oct 2026). Adapted from the Noche Y Dia cart (assets/nyd-cart.js)
   WITHOUT the free-gift sync, decline flags or checkout guard.
   - Wraps window.fetch and XMLHttpRequest: after any successful POST to /cart/add|change|update|clear made by
     the theme, a PDP or an app, it refreshes the cart and opens the slide-out cart after an add.
   - Oct 29: after an add, the slide-out cart waits briefly and does NOT open if the page is already moving on
     (for example the PDP upsell modal sending the shopper to /cart or checkout). Set data-lt-no-drawer on <body>
     or on any element of a page to stop the auto-open there entirely.
   - The header cart icons (Turbo .mini_cart) open the slide-out cart instead of going to /cart.
   - Cart body HTML comes from snippets/lt-cart-core.liquid via ?sections=lt-cart-drawer,lt-cart-page. */
(function () {
  'use strict';
  if (window.LTCart || !window.fetch || !window.Promise) return;

  var RE = /\/cart\/(add|change|update|clear)(\.js)?$/;
  var JSONH = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  var OPEN_DELAY = 900; /* ms to wait after an add before opening, so a redirect can win */
  var of = window.fetch.bind(window);
  var d = document, lastOpener = null, internal = 0, leaving = false, openTimer = null;

  function $(s, r) { return (r || d).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function post(u, b) { return of(u, { method: 'POST', credentials: 'same-origin', headers: JSONH, body: JSON.stringify(b) }); }
  function getCart() { return of('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
  function onCartPage() { return /^\/cart\/?$/i.test(location.pathname); }
  function drawer() {
    var el = $('[data-lt-drawer]');
    /* keep the drawer a direct child of <body> so no header or footer styles can trap it */
    if (el && el.parentNode !== d.body) d.body.appendChild(el);
    return el;
  }

  /* the page is navigating away (redirect to /cart, checkout, another page): never pop the drawer */
  function markLeaving() { leaving = true; if (openTimer) { clearTimeout(openTimer); openTimer = null; } }
  window.addEventListener('beforeunload', markLeaving);
  window.addEventListener('pagehide', markLeaving);
  window.addEventListener('pageshow', function (e) { if (e.persisted) leaving = false; });
  d.addEventListener('submit', function (e) {
    var f = e.target, a = (f && f.getAttribute && f.getAttribute('action')) || '';
    if (/\/cart|\/checkout/.test(a) && !e.defaultPrevented) markLeaving();
  });

  /* ---------- rendering ---------- */
  function setCount(n) {
    $$('.cart_count').forEach(function (el) { el.textContent = n; });
    $$('[data-lt-n]').forEach(function (el) { el.textContent = '(' + n + ')'; });
  }
  function unbusy() { $$('[data-lt-body].is-busy').forEach(function (b) { b.classList.remove('is-busy'); }); }
  function render() {
    var ids = [];
    if (drawer()) ids.push('lt-cart-drawer');
    if ($('[data-lt-page]')) ids.push('lt-cart-page');
    var jobs = [getCart().then(function (c) { setCount(c.item_count); }).catch(function () {})];
    if (ids.length) {
      jobs.push(of(location.pathname + '?sections=' + ids.join(','), { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (s) {
          ids.forEach(function (id) {
            if (!s[id]) return;
            var tmp = d.createElement('div'); tmp.innerHTML = s[id];
            var nb = $('[data-lt-body]', tmp);
            var host = id === 'lt-cart-drawer' ? drawer() : $('[data-lt-page]');
            var ob = host && $('[data-lt-body]', host);
            if (nb && ob) ob.innerHTML = nb.innerHTML;
          });
        }).catch(function () {}));
    }
    return Promise.all(jobs).then(unbusy, unbusy);
  }
  function busy(el, on) {
    var b = el && el.closest('[data-lt-body]'); if (!b) return;
    b.classList.toggle('is-busy', !!on);
    if (on) setTimeout(function () { b.classList.remove('is-busy'); }, 8000);
  }
  function say(msg) { var l = $('[data-lt-live]'); if (l) { l.textContent = ''; setTimeout(function () { l.textContent = msg; }, 50); } }

  /* ---------- drawer ---------- */
  function openCart(opener) {
    var dl = drawer();
    if (onCartPage()) { render(); return; }
    if (!dl) { location.href = '/cart'; return; }
    lastOpener = opener || d.activeElement;
    dl.hidden = false;
    d.documentElement.classList.add('ltc-lock');
    requestAnimationFrame(function () { dl.classList.add('is-open'); });
    setTimeout(function () { var t = $('#ltc-title'); if (t) t.focus(); }, 60);
    render();
  }
  function closeCart() {
    var dl = drawer(); if (!dl || dl.hidden) return;
    dl.classList.remove('is-open');
    d.documentElement.classList.remove('ltc-lock');
    setTimeout(function () { dl.hidden = true; }, 250);
    if (lastOpener && lastOpener.focus) lastOpener.focus();
  }

  /* ---------- watch cart calls made by the theme, PDPs and apps ---------- */
  function afterExternal(path) {
    var isAdd = /\/cart\/add/.test(path);
    if (isAdd && drawer() && !onCartPage() && !$('[data-lt-no-drawer]')) {
      if (openTimer) clearTimeout(openTimer);
      openTimer = setTimeout(function () {
        openTimer = null;
        if (!leaving) openCart(); else render();
      }, OPEN_DELAY);
    } else {
      render();
    }
  }
  function pathOf(u) { return String(u || '').replace(/^https?:\/\/[^\/]+/i, '').split(/[?#]/)[0]; }

  window.fetch = function (input, init) {
    var p = of(input, init);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var m = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      var path = pathOf(url);
      if (internal || m !== 'POST' || !RE.test(path)) return p;
      return p.then(function (res) { if (res && res.ok) afterExternal(path); return res; });
    } catch (e) { return p; }
  };
  (function () {
    var XO = XMLHttpRequest.prototype.open, XS = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { this._lt = { m: String(m).toUpperCase(), p: pathOf(u) }; return XO.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function () {
      var x = this, i = x._lt;
      if (i && i.m === 'POST' && RE.test(i.p)) {
        x.addEventListener('load', function () { if (x.status >= 200 && x.status < 300) afterExternal(i.p); });
      }
      return XS.apply(this, arguments);
    };
  })();

  /* ---------- clicks ---------- */
  function mine(fn) { internal++; return Promise.resolve().then(fn).then(function (v) { internal--; return v; }, function (e) { internal--; throw e; }); }

  /* header cart icons: capture phase so Turbo's own cart dropdown never opens */
  d.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    var cartLink = t.closest('a.mini_cart, a.icon-cart[href="/cart"], a.icon-bag[href="/cart"]');
    if (cartLink && !t.closest('[data-lt-drawer]') && drawer() && !onCartPage()) {
      e.preventDefault(); e.stopPropagation();
      openCart(cartLink);
    }
  }, true);

  d.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    var close = t.closest('[data-lt-close]');
    if (close) { e.preventDefault(); closeCart(); return; }
    var qtyBtn = t.closest('[data-lt-qty]');
    if (qtyBtn) {
      e.preventDefault(); busy(qtyBtn, true);
      var qty = Math.max(0, parseInt(qtyBtn.getAttribute('data-lt-qty'), 10) || 0);
      mine(function () { return post('/cart/change.js', { id: qtyBtn.getAttribute('data-key'), quantity: qty }); })
        .then(render).then(function () { say(qty === 0 ? 'Item removed' : 'Quantity updated'); })
        .catch(function () { render(); });
    }
  });
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape' || e.key === 'Esc') closeCart(); });

  window.LTCart = { open: openCart, close: closeCart, refresh: render };
})();
